<div class="container-fluid p-3">
  <mat-card>
    <mat-card-header class="pb-0">
      <mat-card-title>Crear Cita Futura</mat-card-title>
    </mat-card-header>
    <mat-card-content class="pt-3">
      <form [formGroup]="citaForm" (ngSubmit)="onSubmit()">
        <div class="row g-3 align-items-center mb-3">
          <div class="col-12 col-md-3">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Periodo</mat-label>
              <mat-select formControlName="periodo" (selectionChange)="onPeriodoChange($event)" required>
                <mat-option *ngFor="let periodo of periodosAbiertos" [value]="periodo.periodo">
                  {{periodo.periodo}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="citaForm.get('periodo')?.hasError('required')">
                El periodo es requerido
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="row g-3 align-items-center">

          <div class="col-12 col-md-3">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Departamentos</mat-label>
              <input matInput [formControl]="departamentoCtrl" [matAutocomplete]="autoDepartamento"
                (focus)="departamentoCtrl.setValue('')" [placeholder]="getDepartamentoPlaceholder()">
              <button mat-icon-button matSuffix (click)="departamentoCtrl.setValue('')">
                <mat-icon>arrow_drop_down</mat-icon>
              </button>
              <mat-autocomplete #autoDepartamento="matAutocomplete" [displayWith]="displayDepartamento">
                <mat-option *ngFor="let departamento of departamentosFiltrados | async" [value]="departamento">
                  <mat-checkbox [checked]="isDepartamentoSeleccionado(departamento)"
                    (change)="toggleSeleccionDepartamento(departamento, $event)" (click)="$event.stopPropagation()">
                    {{departamento.nombre_departamento}}
                  </mat-checkbox>
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </div>

          <div class="col-12 col-md-3">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Ciudades</mat-label>
              <input matInput [formControl]="ciudadCtrl" [matAutocomplete]="auto" (focus)="ciudadCtrl.setValue('')"
                [placeholder]="getCiudadPlaceholder()" placeholder="Buscar ciudad...">
              <button mat-icon-button matSuffix (click)="ciudadCtrl.setValue('')">
                <mat-icon>arrow_drop_down</mat-icon>
              </button>
              <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayCiudad">
                <mat-option *ngFor="let ciudad of ciudadesFiltradas | async" [value]="ciudad">
                  <mat-checkbox [checked]="isCiudadSeleccionada(ciudad)"
                    (change)="toggleSeleccionCiudad(ciudad, $event)" (click)="$event.stopPropagation()">
                    {{ciudad.nombre_municipio}}
                  </mat-checkbox>
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </div>

          <div class="col-12 col-md-6">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Tienda</mat-label>
              <input matInput [formControl]="tiendaCtrl" [matAutocomplete]="autoTienda"
                (focus)="tiendaCtrl.setValue('')" [placeholder]="getTiendaPlaceholder()">
              <button mat-icon-button matSuffix (click)="tiendaCtrl.setValue('')">
                <mat-icon>arrow_drop_down</mat-icon>
              </button>
              <mat-autocomplete #autoTienda="matAutocomplete">
                <mat-option>
                  <mat-checkbox [checked]="todasLasTiendasSeleccionadas" [indeterminate]="algunasTiendasSeleccionadas"
                    (change)="toggleTodasLasTiendas($event)" (click)="$event.stopPropagation()">
                    TODAS LAS TIENDAS
                  </mat-checkbox>
                </mat-option>
                <mat-option *ngFor="let tienda of tiendasFiltradas | async" [value]="tienda">
                  <mat-checkbox [checked]="isTiendaSeleccionada(tienda)"
                    (change)="toggleSeleccionTienda(tienda, $event)" (click)="$event.stopPropagation()">
                    {{tienda.c_age}} - {{tienda.nom}}
                  </mat-checkbox>
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </div>

        </div>

        <div class="d-flex gap-2 mt-3 justify-content-end">
          <div class="d-flex gap-2">
            <button mat-flat-button color="primary" type="submit"
              [disabled]="!citaForm.valid || tiendasSeleccionadas.length === 0 || isLoading" class="btn btn-primary">
              <span *ngIf="!isLoading">{{ isEditing ? 'Actualizar' : 'Guardar' }}</span>
            </button>
          </div>
        </div>
      </form>


    </mat-card-content>
  </mat-card>

  <mat-card class="mt-3">
    <mat-card-header class="pb-0">
      <mat-card-title>Lista de Citas Futuras</mat-card-title>
    </mat-card-header>
    <mat-card-content class="pt-3">
      <div class="row mb-3">
        <div class="col-md-6">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Buscar</mat-label>
            <input matInput (keyup)="applyFilter($event)" placeholder="Buscar por código o nombre de agencia...">
            <mat-icon matSuffix class="text-dark">search</mat-icon>
          </mat-form-field>
        </div>
        <div class="col-md-6">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Filtrar por Periodo</mat-label>
            <mat-select [(ngModel)]="periodoFiltro" (selectionChange)="aplicarFiltros()">
              <mat-option value="">Todos los periodos</mat-option>
              <mat-option *ngFor="let periodo of todosLosPeriodos" [value]="periodo.periodo">
                {{periodo.periodo}} ({{periodo.estadoperiodo}})
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <div class="table-responsive">
        <table mat-table [dataSource]="dataSource"  class="table w-100">
          <!-- Columnas de la tabla -->
          <ng-container matColumnDef="periodo">
            <th mat-header-cell *matHeaderCellDef style="width: 15%; font-size: 11px;">Periodo</th>
            <td mat-cell *matCellDef="let element" style="vertical-align: middle; font-size: 11px;">{{element.periodo}}
            </td>
          </ng-container>

          <ng-container matColumnDef="codigo_agencia">
            <th mat-header-cell *matHeaderCellDef  style="width: 30%; font-size: 11px; text-align: center;">Código Agencia
            </th>
            <td mat-cell *matCellDef="let element"  style="vertical-align: middle; text-align: center;">{{element.c_age}}</td>
          </ng-container>

          <ng-container matColumnDef="nombre_agencia">
            <th mat-header-cell *matHeaderCellDef  style="width:40%; font-size: 11px;">Nombre Agencia
            </th>
            <td mat-cell *matCellDef="let element" style="vertical-align: middle; font-size: 11px;">
              {{getNombreTienda(element.c_age)}}
            </td>
          </ng-container>

          <ng-container matColumnDef="acciones">
            <th mat-header-cell *matHeaderCellDef style="width: 20%; text-align: center; font-size: 11px;">Acciones</th>
            <td mat-cell *matCellDef="let element" style="vertical-align: middle;">
              <div style="display: flex; justify-content: center; gap: 4px; ">
                <button mat-icon-button color="warn" (click)="eliminarRegistro(element)" class="text-dark">
                  <mat-icon style="font-size: 1.3rem;">delete</mat-icon>
                </button>
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

          <!-- Mensaje cuando no hay datos -->
          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell text-center" [attr.colspan]="displayedColumns.length" style="padding: 20px;">
              No se encontraron registros
            </td>
          </tr>
          
        </table>

        <mat-paginator [length]="totalItems" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions"
          [pageIndex]="currentPage" (page)="onPageChange($event)" showFirstLastButtons>
        </mat-paginator>
      </div>

    </mat-card-content>
  </mat-card>
</div>